import React, { createContext, useCallback, useContext, useState } from 'react';
import confetti from 'canvas-confetti';

const DownloadContext = createContext();

export const useDownload = () => useContext(DownloadContext);

// How many downloads before we (gently) ask for a coffee.
const COFFEE_THRESHOLD = 3;

const celebrate = () => {
    const colors = ['#22c55e', '#10b981', '#fbbf24', '#f43f5e', '#3b82f6'];

    // Single celebratory burst from the middle of the screen.
    confetti({
        particleCount: 140,
        spread: 100,
        startVelocity: 45,
        origin: { x: 0.5, y: 0.6 },
        colors,
    });
};

export const DownloadProvider = ({ children }) => {
    const [count, setCount] = useState(0);
    const [showCoffee, setShowCoffee] = useState(false);
    const [downloading, setDownloading] = useState(null);

    const closeCoffee = useCallback(() => {
        setShowCoffee(false);
        setCount(0);
    }, []);

    const download = useCallback(async (url, filename) => {
        try {
            setDownloading(url);
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = filename || 'pixiy-download';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

            celebrate();

            setCount((prev) => {
                const next = prev + 1;
                if (next >= COFFEE_THRESHOLD) {
                    setShowCoffee(true);
                }
                return next;
            });
        } catch (err) {
            console.log('Download failed', err);
            // Fallback: open the asset in a new tab so the user can still save it.
            window.open(url, '_blank', 'noopener,noreferrer');
        } finally {
            setDownloading(null);
        }
    }, []);

    return (
        <DownloadContext.Provider value={{ download, downloading, count, showCoffee, closeCoffee }}>
            {children}
        </DownloadContext.Provider>
    );
};

export default DownloadContext;
